// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { DrugActions, DrugActionTypes } from '../_actions/drug.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Drug } from '../_models/drug.model';

// tslint:disable-next-line:no-empty-interface
export interface DrugsState extends EntityState<Drug> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedDrugId: number;
  lastCreatedDrug: Drug;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Drug> = createEntityAdapter<Drug>();

export const initialDrugsState: DrugsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedDrugId: undefined,
  lastCreatedDrug: undefined,
  showInitWaitingMessage: true,
});

export function drugsReducer(state = initialDrugsState, action: DrugActions): DrugsState {
  switch (action.type) {
    case DrugActionTypes.DrugsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedDrugId: undefined,
      };
    case DrugActionTypes.DrugsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case DrugActionTypes.DrugCreated:
      return adapter.addOne(action.payload.drug, {
        ...state,
        lastCreatedDrugId: action.payload.drug.id,
        lastCreatedDrug: action.payload.drug,
      });
    case DrugActionTypes.DrugUpdated:
      return adapter.updateOne(action.payload.partialDrug, state);
    case DrugActionTypes.DrugDeleted:
      return adapter.removeOne(action.payload.id, state);
    case DrugActionTypes.DrugsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case DrugActionTypes.DrugsPageLoaded: {
      return adapter.addMany(action.payload.drugs, {
        ...initialDrugsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case DrugActionTypes.ThrowDrugError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case DrugActionTypes.FireDrugSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getDrugState = createFeatureSelector<DrugsState>('drugs');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
